import { useEffect, useState, Suspense } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import OnboardingPageContent from '../onboarding/OnboardingPageContent';
import { fetchLinkedInProfile } from '../lib/actions/linkedin';

function OnboardingPageLoading() {
  return (
    <div className="min-h-screen flex items-center justify-center p-3 sm:p-4 md:p-6"></div>
  );
}

export default function OnboardingPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [linkedinUserData, setLinkedinUserData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const accessToken = searchParams.get('access_token');
    const refreshToken = searchParams.get('refresh_token');
    const tokenFromUrl = searchParams.get('_token');

    if (accessToken) {
      const callbackParams = new URLSearchParams({
        access_token: accessToken,
        ...(refreshToken && { refresh_token: refreshToken }),
        redirect: '/onboarding',
      });

      searchParams.forEach((value, key) => {
        if (key !== 'access_token' && key !== 'refresh_token') {
          callbackParams.append(key, value);
        }
      });

      navigate(`/api/auth/callback?${callbackParams.toString()}`);
      return;
    }

    if (tokenFromUrl) {
      fetchLinkedInProfile(true, tokenFromUrl)
        .then((data) => {
          setLinkedinUserData(data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error('Failed to fetch LinkedIn profile:', error);
          setLinkedinUserData(null);
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, [searchParams, navigate]);

  if (isLoading) {
    return <OnboardingPageLoading />;
  }

  return (
    <Suspense fallback={<OnboardingPageLoading />}>
      <OnboardingPageContent linkedinUserData={linkedinUserData} />
    </Suspense>
  );
}
